import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnlock = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "var(--main-color)",
		children: /* @__PURE__ */ _jsx("path", {
			clipRule: "evenodd",
			d: "m5.43266 6.01507c.68276-2.87149 3.44292-5.01507 6.73404-5.01507 3.8085 0 6.875 2.80363 6.875 6.28571v1.04762c1.2524 0 2.2916.95013 2.2916 2.09527v10.4762c0 1.1451-1.0392 2.0952-2.2916 2.0952h-13.75003c-1.25247 0-2.29167-.9501-2.29167-2.0952v-10.4762c0-1.14514 1.0392-2.09527 2.29167-2.09527h11.45833v-1.04762c0-2.38458-1.9752-4.19047-4.5833-4.19047-2.20895 0-4.03077 1.41832-4.49385 3.36588zm13.60904 14.88973v-10.4762h-13.75003v10.4762zm-7.8962-6.1495-1.14857 1.0312c-.35105.3144-.90648.3015-1.24058-.0288-.33411-.3304-.32037-.853.03068-1.1674l2.63017-2.3594c.0381-.035.0827-.0629.1315-.0825.0413-.0351.0888-.063.1403-.0825.2122-.0883.4541-.0883.6663 0 .1077.0392.206.0981.2894.1732l2.6302 2.475c.3438.3234.3438.8479 0 1.1714s-.9012.3235-1.245 0l-1.131-1.0725v3.6934c0 .4556-.3911.8266-.8753.8266s-.8781-.371-.8781-.8266z",
			fillRule: "evenodd"
		})
	})
});
export { SvgUnlock as ReactComponent };
